import React from 'react'
import SearchComp from '../Components/SearchComp'



function Explore() {
  return (
    <div>
      <SearchComp />
    </div>
  )
}

export default Explore
